import { render } from "./SerialConfirm.vue?vue&type=template&id=3dd942f6"
import script from "./SerialConfirm.vue?vue&type=script&lang=js"
export * from "./SerialConfirm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Nomura\\PROJECT\\010.Src_By_SYSLAB\\007.MCSC_Web\\Git_main\\FrontEnd\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__